import React from "react";
import { toast } from "react-toastify";
import ToastMessage from "../components/common/ToastMessage";

const TOAST_EXTRA_DURATION_MS = 2000;

const DEFAULTS = {
  success: { autoClose: 1800, title: "Success" },
  error: { autoClose: 2600, title: "Error" },
  warning: { autoClose: 2400, title: "Warning" },
  info: { autoClose: 2000, title: "Notice" }
};

const normalizeTone = (tone) => {
  if (tone === "success" || tone === "error" || tone === "warning" || tone === "info") {
    return tone;
  }
  return "info";
};

const toMessageText = (message) => {
  if (typeof message === "string") {
    return message.trim();
  }
  if (message === null || message === undefined) {
    return "";
  }
  if (typeof message === "object") {
    if (typeof message.message === "string") {
      return message.message.trim();
    }
    try {
      return JSON.stringify(message);
    } catch (error) {
      return String(message);
    }
  }
  return String(message);
};

const open = (tone, message, options = {}) => {
  const resolvedTone = normalizeTone(tone);
  const defaults = DEFAULTS[resolvedTone];
  const text = toMessageText(message);
  if (text === "") {
    return null;
  }

  const baseAutoClose = (typeof options.autoClose === "number" ? options.autoClose : defaults.autoClose);

  const toastId = (
    options.dedupe === false
      ? undefined
      : (options.toastId || (resolvedTone + ":" + text))
  );

  return toast(
    ({ closeToast }) => (
      <ToastMessage
        tone={resolvedTone}
        title={(typeof options.title === "string" && options.title.trim() !== "" ? options.title : defaults.title)}
        message={text}
        onClose={closeToast}
      />
    ),
    {
      toastId,
      autoClose: baseAutoClose + TOAST_EXTRA_DURATION_MS,
      closeButton: false,
      icon: false,
      className: "app-toast-shell app-toast-" + resolvedTone,
      bodyClassName: "app-toast-body-wrap",
      progressClassName: "app-toast-progress",
      hideProgressBar: !!options.hideProgressBar
    }
  );
};

export const notify = {
  success: (message, options = {}) => open("success", message, options),
  error: (message, options = {}) => open("error", message, options),
  warning: (message, options = {}) => open("warning", message, options),
  info: (message, options = {}) => open("info", message, options),
  dismiss: (id) => toast.dismiss(id)
};

export default notify;
